<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class=   "ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Display Supplier Group',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Supplier Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-plus" tooltip="New" @click="handleNew" v-if="hasPermission(perm.supplier_group.create)"/>
                            <PIconBtn icon="mdi-pencil" tooltip="Edit" @click="handleEdit" v-if="hasPermission(perm.supplier_group.update)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="handleList" v-if="hasPermission(perm.supplier_group.index)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierGroup :value="data" v-if="!loading"/>
                </v-sheet>
            </v-col>
        </v-row>
        <LoadingOverlay v-model="loading"/>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import LoadingOverlay from './../../components/common/LoadingOverlay'
import PAlert from './../../components/common/PAlert' 
import { mapActions, mapGetters } from 'vuex'
import PIconBtn from './../../components/common/PIconBtn.vue'
import SupplierGroup from './../../components/purchase/SupplierGroup.vue'
export default {
    name : "SupplierGroupDisplayView",
    components: {
        PIconBtn,
        SupplierGroup,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            id: null,
            loading: false,
            data: {},
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplierGroup/findByID",
            snackbar: "ui/snackbar/show"
        }),
        fetchSupplierGroup() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error" }) 
            }).finally(() => {
                this.loading = false;
            })
        },
        handleNew() {
            this.$router.push({ name: "SupplierGroupCreate" });
        },
        handleEdit() {
            this.$router.push({ name: "SupplierGroupEdit", params: { id: this.id } })
        },
        handleList() {
            this.$router.push({ name: "SupplierGroupList" })
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchSupplierGroup()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchSupplierGroup()
        next()
    }
}
</script>

<style>

</style>